<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <div v-if="!loading && storeData">
      <div class="mt-1">

        <DrugInfo
          ref="drugInfo"
          :drug="drug"
          :locality="$editNewOrder"
        />

        <!--        <DrugInStore :storeId="selectedStoreId" :drug="{id: this.drug.id}" :storeData="storeData"/>-->

        <OrderPriceLine
          :drug="drug"
          :divId="divisionId"
          :actualPrice="actualPrice"
          :showCoolCondition="true"
        />

        <div class="mt-1 mb-1">
          <button @click="() => sendDrugMessage({...drug, actualPrice, prices: drugPrices})" type="button"
                  class="btn btn-outline-info btn-xs"><i class="icon-fa icon-fa-arrow-left"></i> Отправить препарат в
            чат
          </button>
          <button
            @click="() => addDrugToOrder({...drug, qty: 1, actual_price: actualPrice, price:actualPrice, prices: drugPrices})"
            type="button"
            class="btn btn-outline-success btn-xs mt-1"><i class="icon-fa icon-fa-arrow-down"></i> добавить в
            заявку
          </button>
        </div>

        <RecommendedDeliveryDate
          :deliveryDate="deliveryDate"
          :cityId="selectedCityId"
        />
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import DrugInStore from "@/components/stores/DrugInStore.vue";
import RecommendedDeliveryDate from "@/views/orders/components/RecommendedDeliveryDate.vue";
import moment from "moment";
import OrderPriceLine from "@/components/drugs/OrderPriceLine.vue";
import DrugInfo from "@/components/drugs/DrugInfoForOrder.vue";

export default {
  components: {DrugInfo, OrderPriceLine, RecommendedDeliveryDate, DrugInStore},
  props: ['drug', 'selectedCityId', 'projectId', 'sendDrugMessage', 'addDrugToOrder'],
  data() {
    return {
      loading: true,
      selectedStoreId: 3,
      divisionId: 0,
      actualPrice: 0,
      drugPrices: [],
      storeData: null,
      deliveryDate: moment().add(1, 'days').format('YYYY-MM-DD')
    }
  },
  created() {
    this.getData();
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
  },
  watch: {
    selectedCityId: {
      handler: function (val, oldVal) {
        this.updateStore();
      }
    }
  },
  methods: {
    updateStore() {
      this.selectedStoreId = 3;
      const div = Object.values(this.$AllDivisions).find((d) => d.is_active && d.cities.find((c) => c.object_id === +this.selectedCityId && c.city.is_active));
      if (div) {
        this.divisionId = div.id;
        this.selectedStoreId = div.stores[0].object_id;
      }
    },
    async getData() {
      this.loading = true;
      const {data} = await api.index('/new/drugs/info/' + this.drug.id);
      if (data.success) {
        this.updateStore();
        const price = data.drugData.prices.find((p) => p.is_active && p.qty === 1 && p.site_id === +this.projectId);
        this.drugPrices = data.drugData.prices;
        this.drug.prices = this.drugPrices;
        this.actualPrice = price?.price ?? 'не активен на сайте';
        this.storeData = data.storeData;
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера', 'Ошибка!');
      }
      this.loading = false;
    }
  }
}

</script>
